<template>
    <img :src="pixelUrl" style="position: absolute; top: -500px; right: -500px;">
</template>

<script>
export default {
    data() {
        return {
            cacheBuster: 0 // Contatore per forzare l'aggiornamento
        };
    },
    computed: {
        
        pixelUrl() {
            const uid = this.$store.state.userid;
            const index = "giova";

            if(this.$store.state.global_state_pageid == 'home'){
                console.log("found home")
                return `https://cdn.gnet.it/pixel.png?index=${index}&uid=${uid}&page=home&action=-1&_cb=${this.cacheBuster}`;
            }

            const process = this.$store.getters.getProcessStatus;
            const page = process?.processId 
                || this.$store.state.global_state_process 
                || "-1";
                
            const action = process?.verbId 
                || this.$store.state.global_state_verb 
                || "-1";
            
            // Base URL senza cache-buster
            const baseUrl = `https://cdn.gnet.it/pixel.png?index=${index}&uid=${uid}&page=${page}&action=${action}`;
            console.log("base url: ", baseUrl, " cache: ", this.cacheBuster)
            // Aggiungi un parametro univoco per evitare la cache
            return `${baseUrl}&_cb=${this.cacheBuster}`;
        }
    },
    watch: {
        // Ricalcola quando cambiano le dipendenze
        '$store.state.userid': 'updatePixel',
        '$store.getters.getProcessStatus': 'updatePixel',
        '$store.state.global_state_process': 'updatePixel',
        '$store.state.global_state_verb': 'updatePixel',
        '$store.state.global_state_pageid': 'updatePixel',
    },
    mounted() {
        var process = this.$store.getters.getProcessStatus;
        if(process){
            var verb = this.$store.getters.getVerb( this.$store.getters.getProcess(process.processId), process.verbId )
            var objectData = this.$store.getters.getObject(verb.pageid).data
            if(process && objectData && window.OpenReplay)
                window.OpenReplay.issue(process.processId+'_'+process.verbId, { process: process, object: objectData })
        }
        
    },
    methods: {
        updatePixel() {
            // Incrementa il cache-buster per invalidare la cache
            this.cacheBuster++;
        }
    }
};
</script>
